import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { switchMap, distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _loading$ = new BehaviorSubject<boolean>(false);
  public readonly isLoading$ = this._loading$.pipe(
      switchMap(show =>
          show
              ? timer(0).pipe(switchMap(() => [true]))
              : timer(500).pipe(switchMap(() => [false]))
      ),
      distinctUntilChanged()
  );

  private _fallbackTimeout: any;

  startLoader() {
    this._loading$.next(true);

    if (this._fallbackTimeout) {
      clearTimeout(this._fallbackTimeout);
    }

    this._fallbackTimeout = setTimeout(() => {
      if (this._loading$.getValue()) {
        console.warn('LoaderService: fallback automatico dopo 30s');
        this._loading$.next(false);
      }
      this._fallbackTimeout = null;
    }, 30_000);
  }

  stopLoader() {
    this._loading$.next(false);

    if (this._fallbackTimeout) {
      clearTimeout(this._fallbackTimeout);
      this._fallbackTimeout = null;
    }
  }
}
